<template>
  <common-paypal-form 
    @success="onSuccess"
    @error="onError"
    :total="total"
  />
</template>
<script>


import CommonPaypalForm from '@/components/common/paypal-form';

export default {
  components: {
    CommonPaypalForm
  },
  props:{
    total: [String,Number]
  },
  methods:{
    onSuccess(authorizationId){
      $('#paypal-authorization-id').val(authorizationId);
      $('#payment-form').submit();
    },
    onError(error){
      alert(error)
    }
  }
}
</script>

<style scoped>

</style>
